import React, { useState } from "react";
import Config from "../../../../config/Config";
import WidgetAjax from "../../../../widget/WidgetAjax";
import WidgetLoading from "../../../../widget/WidgetLoading";
import WidgetMessage from "../../../../widget/WidgetMessage";
import {checkLogin} from '../../../com/utils'

import './index.scss'

const source = Config.getSourcePath();
const List = ({ loading = false, history }) =>
{
    const [data, setData] = useState([
        {name: "软件销售", num: 7, icon: "market", fileName: "ruanjian" }, 
        {name: "人力资源管理", num: 10, icon: "manpower", fileName: "renli" }, 
        {name: "财务管理", num: 10, icon: "finance", fileName: "caiwu" }, 
        {name: "开发程序员", num: 9, icon: "programmer", fileName: "kaifa" }, 
        {name: "纺织设备技术员", num: 11, icon: "technician", fileName: "bianzhi" },
        {name: "矿山工程职业发展规划", num: 11, icon: "kuangshan", fileName: "kuangshan" }
    ]);

    const turnToDetail = (item) =>
    {
        if(!checkLogin()){
            WidgetMessage.warning('请先登录！');
            setTimeout(() => {
                history.push({ pathname: "/login" });
                window.location.reload();
            }, 1000);
            return false;
        }
        history.push({
            pathname: "/home/profession/detail",
            state: { name: item.fileName }
        });
    }

    return (
        <div component-data={source} className="profession-list">
            <WidgetLoading loading={loading}>
                <div className="profession-list-wrap">
                    {
                        data && data.length > 0
                        ?   data.map((item, index) => {
                            return (
                                <div key={index} className="profession-list-item" onClick={() => turnToDetail(item)}>
                                    <img className='profession-list-item-img' src={require(`../../../../img/${source}/dataSource/tree_${item.icon}.png`)}/>
                                    <div className="profession-list-item-content">
                                        <div className="profession-list-item-title">{item.name}</div>
                                        <div className="profession-list-item-num">{item.num}<span>晋升方向</span></div>
                                    </div>
                                </div>
                            )
                        })
                        :   <></>
                    }
                </div>
            </WidgetLoading>
        </div>
    )
}

export default List;